import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Card, Form, Tabs, Tab } from 'react-bootstrap';
import Loading from '../../Components/Loading';

import {
  ContainerMain,
  CardHeader,
  Title,
  FormGroupCustom,
  FormLabelCustom,
  CardFooterCustom,
  CardIcon,
  ButtonSave,
  ButtonCancel,
  BoxLoading,
  CardBody
} from './styles';
import { MdDescription, } from 'react-icons/md';
import ModalCodeValidate from './Components/ModalCodeValidate';
import CancelModal from '../../Components/CancelModal';
import { useStateValue } from '../../providers/StateProvider';
import { actionTypes } from '../../store/reducer';
import { createRequestDocument, getVisualizationResponse, updateRequestDocument } from '../../services/documents';
import { getOrganHeader } from '../../services/organ';
import MyEditor from '../../Components/MyEditor';

interface HeaderProps {
  conteudo: string;
  created_at: string;
  id: string;
  orgao: number;
  titulo: string;
  updated_at: string;
  user: any;
}
export interface DocumentProps {
  assunto: string;
  cabecalho: string;
  conteudo: string;
  created_at: string;
  hash?: string;
  id: string;
  solicitacao: number;
  updated_at: string;
  user: any;
}

const AttachDocument = () => {
  const history = useHistory();
  const { solicitacao_id, orgao_id, solicitacao, id_documento } = useParams<{ solicitacao_id: string; orgao_id: string; solicitacao?: string, id_documento: string }>();
  const [, dispatch] = useStateValue();
  const [showModalCode, setShowModalCode] = useState(false);
  const [showModalCancel, setShowModalCancel] = useState(false);
  const [assunto, setAssunto] = useState<string>('');
  const [headers, setHeaders] = useState<HeaderProps[]>();
  const [conteudo, setConteudo] = useState<string>('');
  const [selectCabecalho, setSelectCabecalho] = useState<any>();
  const [documentSaved, setDocumentSaved] = useState<DocumentProps>();
  const [loading, setLoading] = useState<boolean>(false);
  const [existDocument, setExistDocument] = useState(null);

  const handleCancel = () => {
    setShowModalCancel(true);
  }

  const handleCloseCancel = () => {
    history.goBack();
    dispatch({
      type: actionTypes.SET_FLASH_MESSAGE,
      flashMessage: {
        show: true,
        type: 'error-alt',
        title: 'Cancelado',
        message: 'Documento não foi criado.',
      },
    });
  }

  const handleSave = () => {
    setShowModalCode(true);
    dispatch({
      type: actionTypes.SET_FLASH_MESSAGE,
      flashMessage: {
        show: true,
        type: 'success-alt',
        title: 'Sucesso',
        message: 'Documento foi criado com sucesso.',
      },
    });
  }

  const handleCreatedDocument = async () => {
    try {
      setLoading(true);
      if (existDocument) {
        const { data } = await updateRequestDocument(parseInt(solicitacao_id, 10), assunto, conteudo, selectCabecalho.id, solicitacao!, id_documento);
        setDocumentSaved(data);
        setShowModalCode(true);
        dispatch({
          type: actionTypes.SET_FLASH_MESSAGE,
          flashMessage: {
            show: true,
            type: 'success-alt',
            title: 'Sucesso',
            message: 'Documento foi atualizado com sucesso.',
          },
        });
      } else {
        const { data } = await createRequestDocument(
          parseInt(solicitacao_id, 10),
          assunto,
          conteudo,
          selectCabecalho.id
        );
        setDocumentSaved(data);
        handleSave();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const getAllApi = async () => {
    try {
      const organ = await getOrganHeader(orgao_id);
      setHeaders(organ.data.results);
      if (!id_documento) {
        return;
      }
      if (!solicitacao) {
        dispatch({
          type: actionTypes.SET_FLASH_MESSAGE,
          flashMessage: {
            show: true,
            type: 'error-alt',
            title: 'Não foi possível carregar',
            message: 'Identificador da solicitação ausente na URL. Use a rota com o caminho completo do documento.',
          },
        });
        return;
      }
      const document = await getVisualizationResponse(id_documento, solicitacao);
      setExistDocument(document.data);
    } catch (error) {
      console.error(error);
      dispatch({
        type: actionTypes.SET_FLASH_MESSAGE,
        flashMessage: {
          show: true,
          type: 'error-alt',
          title: 'Erro ao carregar documento',
          message: 'Não foi possível obter os dados do documento de resposta. Tente novamente.',
        },
      });
    }
  };

  useEffect(() => {
    getAllApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!existDocument) {
      return;
    }
    setAssunto(existDocument.assunto ?? '');
    const cab = existDocument.cabecalho;
    if (cab != null && headers?.length) {
      const idRef = typeof cab === 'object' && cab != null && 'id' in cab ? (cab as { id: string | number }).id : cab;
      const fromList = headers.find((h) => String(h.id) === String(idRef));
      setSelectCabecalho(fromList ?? (typeof cab === 'object' ? cab : undefined));
    } else if (cab && typeof cab === 'object' && cab.id != null) {
      setSelectCabecalho(cab);
    } else {
      setSelectCabecalho(cab);
    }
    setConteudo(existDocument.conteudo ?? '');
  }, [existDocument, headers]);



  return (
    <>
      {documentSaved && (
        <ModalCodeValidate documents={documentSaved} show={showModalCode} setShow={setShowModalCode} />
      )}
      <ContainerMain>
        <form onSubmit={(e) => e.preventDefault()}>
          <Card>
            <CardHeader>
              <div>
                <CardIcon>
                  <MdDescription size={20} />
                </CardIcon>
              </div>
              <Title>
                {existDocument ? 'Atualizar ' : 'Criar '}documento
              </Title>
            </CardHeader>
            <Tabs defaultActiveKey="edit" className="mb-3">
              <Tab eventKey="edit" title="Editar">
                <>
                  <Card.Body>
                    <FormGroupCustom className="mb-3" controlId="">
                      <FormLabelCustom required>Assunto</FormLabelCustom>
                      <Form.Control
                        required
                        value={assunto}
                        onChange={(e) => setAssunto(e.target.value)}
                      >
                      </Form.Control>
                      <Form.Text className="text-muted">
                        Informe o assunto do documento
                      </Form.Text>
                    </FormGroupCustom>
                    <FormGroupCustom className="mb-3" controlId="">
                      <FormLabelCustom required>Cabeçalho</FormLabelCustom>
                      <Form.Select
                        value={
                          selectCabecalho?.id != null && selectCabecalho.id !== ''
                            ? String(selectCabecalho.id)
                            : 'none'
                        }
                        onChange={(e) => {
                          const v = e.target.value;
                          if (v === 'none') {
                            setSelectCabecalho(undefined);
                            return;
                          }
                          const findHeader = headers?.find(
                            (header) => String(header.id) === String(v)
                          );
                          setSelectCabecalho(findHeader);
                        }}
                      >
                        <option value="none">Selecione</option>
                        {headers?.map((header) => (
                          <option key={header.id} value={header.id}>
                            {header.titulo}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Text className="text-muted">
                        Informe o cabeçalho do documento
                      </Form.Text>
                    </FormGroupCustom>
                    <FormGroupCustom>
                      <FormLabelCustom required>Conteúdo</FormLabelCustom>
                      <MyEditor
                        value={conteudo}
                        setValue={setConteudo}
                        modeEdit='full'
                        addConf={{
                          height: 300
                        }}
                      />
                      <Form.Text className="text-muted">
                        Informe o conteúdo do documento
                      </Form.Text>
                    </FormGroupCustom>
                  </Card.Body>
                  <CardFooterCustom>
                    <ButtonCancel
                      onClick={handleCancel}>
                      Cancelar
                    </ButtonCancel>
                    {loading ? (
                      <BoxLoading>
                        <Loading />
                      </BoxLoading>
                    ) : (
                      <ButtonSave
                        disabled={
                          !assunto ||
                          !selectCabecalho?.id
                        }
                        onClick={handleCreatedDocument}
                      >
                        {existDocument ? 'Atualizar' : 'Salvar'}
                      </ButtonSave>
                    )}
                  </CardFooterCustom>
                </>
              </Tab>
              <Tab eventKey="preview" title="Prévia">
                <CardBody>
                  <MyEditor
                    value={
                      `${selectCabecalho ? selectCabecalho?.conteudo : ''}
                      ${conteudo ?? ''}`}
                    disabled={true}
                    addConf={{
                      height: 600,
                    }}
                  />
                </CardBody>
              </Tab>
            </Tabs>
          </Card>
        </form>
      </ContainerMain>

      <CancelModal
        show={showModalCancel}
        handleShow={setShowModalCancel}
        title="Cancelar documento"
        description='Tem certeza que deseja cancelar este documento? Essa ação não pode ser desfeita.'
        handleActionOk={handleCloseCancel}
      />
    </>
  );
}

export default AttachDocument;